import type { ViewOption } from '@/engine/app/interfaces';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';
import type { VisibilityLinkedVMController } from './VisibilityLinkedVMController';

export class SetViewOptionVisibilityCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private readonly _visibilityLinkedVmController: VisibilityLinkedVMController;

  private readonly _viewOption: ViewOption;

  private readonly _isVisible: boolean;

  public constructor(
    viewsService: ViewsService,
    visibilityLinkedVmController: VisibilityLinkedVMController,
    viewOption: ViewOption,
    isVisible: boolean
  ) {
    this._viewsService = viewsService;
    this._visibilityLinkedVmController = visibilityLinkedVmController;
    this._viewOption = viewOption;
    this._isVisible = isVisible;
  }

  public execute(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        object.setVisibility(this._isVisible);
        this._visibilityLinkedVmController.setLinkedObjectVisibility(
          object.descriptor,
          this._viewsService.currentView,
          this._isVisible
        );
      }
    }
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        const visibility = !this._isVisible;
        object.setVisibility(visibility);
        this._visibilityLinkedVmController.setLinkedObjectVisibility(
          object.descriptor,
          this._viewsService.currentView,
          visibility
        );
      }
    }
    return Promise.resolve(true);
  }
}
